import React from 'react';
import { motion } from 'framer-motion';
import { ZapIcon } from 'lucide-react';
export const VideoDemoSection = () => {
  return <section id="video-demo" className="py-16 md:py-24 bg-brand-darkest relative overflow-hidden" data-id="element-684">
      <div className="container mx-auto px-4" data-id="element-685">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-686">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-black mb-4" data-id="element-687">
            Real <span className="text-brand-glow" data-id="element-688">Action</span>
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto" data-id="element-689">
            Watch how the QTap tag works in real life — one tap to unlock your
            profile
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="max-w-4xl mx-auto" data-id="element-690">
          <div className="glass-panel p-4 md:p-8 rounded-2xl" data-id="element-691">
            <div className="aspect-square rounded-xl overflow-hidden relative bg-black" data-id="element-692">
              <video src="https://cdn.magicpatterns.com/uploads/3qD7L2WGzj2byBfSx9XXrX/WhatsApp%20Video%202026-03-24%20at%204.21.47%20PM.mp4" autoPlay loop muted playsInline className="w-full h-full object-cover" data-id="element-693" />
            </div>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} className="text-center mt-10 md:mt-14" data-id="element-694">
          <a href="#pricing" className="inline-flex items-center justify-center gap-2.5 bg-brand-cyan hover:bg-brand-glow text-white font-bold text-base md:text-lg py-4 px-8 md:px-10 rounded-full transition-all shadow-[0_0_20px_rgba(0,102,255,0.4)] hover:shadow-[0_0_35px_rgba(0,102,255,0.8)] hover:-translate-y-1" data-id="element-695">
            <ZapIcon className="w-5 h-5 fill-current" data-id="element-696" />
            Grab Yours Before They're Gone
          </a>
          <p className="text-gray-500 text-sm mt-3" data-id="element-697">
            Limited edition — bundle & save up to 25%
          </p>
        </motion.div>
      </div>
    </section>;
};